import { useEffect, useRef, useState, useCallback } from "react";
import { api, useAuth } from "@/context/AuthContext";

export default function useProgress(key, initial) {
  const { user } = useAuth();
  const [data, setData] = useState(() => {
    try {
      const raw = localStorage.getItem(`nc_${key}`);
      return raw ? { ...initial, ...JSON.parse(raw) } : initial;
    } catch (e) { return initial; }
  });
  const [ready, setReady] = useState(false);
  const timer = useRef(null);
  const loaded = useRef(false);

  useEffect(() => {
    if (!user) { setReady(true); return; }
    api.get(`/progress/${key}`)
      .then((r) => {
        if (r.data?.data && Object.keys(r.data.data).length) setData((d) => ({ ...d, ...r.data.data }));
      })
      .catch((e) => console.warn(`progress load failed for ${key}`, e))
      .finally(() => { loaded.current = true; setReady(true); });
  }, [user, key]);

  useEffect(() => {
    try { localStorage.setItem(`nc_${key}`, JSON.stringify(data)); }
    catch (e) { console.warn(`could not cache progress for ${key} (storage full or blocked)`, e); }
    if (!user || !ready) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      api.put(`/progress/${key}`, { data }).catch((e) => console.warn(`progress save failed for ${key}`, e));
    }, 700);
    return () => clearTimeout(timer.current);
  }, [data, user, key, ready]);

  const patch = useCallback((fn) => setData((d) => ({ ...d, ...(typeof fn === "function" ? fn(d) : fn) })), []);
  return [data, patch, ready];
}
